import { t } from "i18next";
import React from "react";
import CustomImageComponent from "../../components/CustomImageComponent";

const AboutUsSec = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-md-12 col-lg-6 mb-4 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <CustomImageComponent className={"img-fluid"} src={"/assets/img/about-img.png"} alt={"AboutUs"} />
          </div>
          <div
            className="col-md-12 col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            {/* <h3 className="sub-title">{t("about_us_title_part")}</h3> */}
            <h3 className="sub-title">FROM STARTUP TO INDUSTRY LEADER</h3>

            {/* <p>
              {t("about_us_part1")}
            </p> */}
            <p>
              Connect Homes: A journey of 13 Years of excellence
            </p>
            <div className="flex-card">
              <div className="img-block">
                <CustomImageComponent
                  className={"img-fluid"}
                  src={"/assets/img/price-icon.svg"}
                  alt={"Affordable price"}
                />
              </div>
              <div className="content-block">
                {/* <h5>Affordable price</h5> */}
                <p>
                  {t("about_us_part2")}
                </p>
              </div>
            </div>
            <div className="flex-card">
              <div className="img-block">
                <CustomImageComponent
                  className={"img-fluid"}
                  src={"/assets/img/agents-icon.svg"}
                  alt={"Experienced agents"}
                />
              </div>
              <div className="content-block">
                {/* <h5>Experienced agents</h5> */}
                <p>
                  {t("about_us_part3")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSec;
